var map = {
	"./_colors.scss": 3849,
	"./ionic-theme.scss": 5290,
	"./material-theme.scss": 7761,
	"entrypoints/css/_colors.scss": 3849,
	"entrypoints/css/ionic-theme.scss": 5290,
	"entrypoints/css/material-theme.scss": 7761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3634;